export default __webpack_public_path__ + "static/media/facebook.2d156e48.svg";